import styled from "@emotion/styled";
import React, { useState } from "react";
// import book from "../../assets/img/slbook.png";
import { MOBILE_WIDTH, TABLET_WIDTH } from "../../../../../utils/HelperStyles";
import StyledButton from "../../../../StyledButton";
import { UpSaleContainer, BuyButton } from "./upsellStyles";

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Maintitle = styled.div`
  font: normal normal bold 110px "Georgia";
  color: #0432ff;
  text-align: center;

  /* @media (max-width: ${TABLET_WIDTH}) {
    font-size: 60px;
  } */
`;

const MiddleTitle = styled.div`
  font: normal normal bold 60px "Georgia";
  color: #0432ff;

  padding-top: 20px;
  padding-bottom: 20px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  font: normal normal normal 17px "Georgia";
  padding: 0px 8%;

  > p {
    font: normal normal normal 17px "Georgia";
  }

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 14px;
  }
`;

const BottomNote = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 8%;
  margin-top: 25px;
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  max-width: 200px;
  float: right;
  /* shape-outside: url("./images/listSwellBook.png"); */
`;

const Note = styled.div`
  width: 100%;
  font: normal normal bold 16px "Georgia";
  text-decoration: underline;
  text-align: left;
`;

const ActionDiv = styled.div`
  font: normal normal normal 16px "Georgia";
  font-family: Georgia;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  border: 5px dashed #ff644e;
  padding: 40px;
  width: 80%;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const ActionTitle = styled.div`
  font: normal normal bold 23px "Georgia";
  padding-bottom: 15px;
`;
const ActionContent = styled.div`
  font: normal normal normal 16px "Georgia";
  /* font-size: 16px; */
`;

const NotAdd = styled.div`
  font: normal normal normal 16px "Georgia";
  text-align: center;
  cursor: pointer;
  color: #1f1e1e;
`;

const Middlecontent = styled.div`
  font: normal normal bold 30px "Georgia";
  text-align: center;
  display: flex;
  justify-content: center;
`;

interface Props {
  onBuy: () => void;
  onNoThanks: () => void;
  isModal?: boolean;
}

export default function EmailPlayersListSwell(props: Props): JSX.Element {
  const { onBuy, onNoThanks, isModal } = props;
  const [loading, setLoading] = useState(false);

  return (
    <UpSaleContainer>
      <Header>
        <Maintitle>What?</Maintitle>

        <MiddleTitle style={{ maxWidth: "70%" }}>
          You Want A Bigger Email List, TOO?
        </MiddleTitle>
      </Header>
      <Content>
        <p>All right then!</p>
        <p>
          If you act before leaving this page, you can also have BerserkerMail’s
          other co-founder Ben Settle’s controversial Email Players List Swell
          book (a physical book, mailed to you, it is NOT digitally delivered —
          and comes with FREE shipping worldwide) for 50% off what it normally
          costs.
        </p>

        <p>
          <Img src={"./images/listSwellBook.png"} />
          Ben has arguably one of the single most responsive lists in his niche.
          But he also admits he is NOT the “list” guy, and wouldn’t know how to
          run a paid ad if his life depended on it, nor does he use or teach
          social media. He also admits there’s nothing “new” about any of the
          methods in this book, they’re mostly slow & tedious… and it could be
          months before you see results. But,{" "}
          <b>
            <u>
              they require little or no money to use, and have helped him build
              one of the most responsive email lists of loyal, eager-to-buy &
              quick-to-refer leads in his industry.
            </u>
          </b>{" "}
          He believes they can probably help nearly any other kind of online
          business build such a list, too, if you have patience, and if you
          aren’t allergic to hard work.
          <p></p>
          Add Email Players List Swell to your BerserkerMail order below, and
          it’s yours for 50% off:
        </p>
      </Content>
      <Middlecontent style={{ marginTop: 0, marginBottom: 0 }}>
        $320.00
      </Middlecontent>
      <p>(reg price is $641.00)</p>
      <Content style={{ textAlign: "left", width: "100%" }}>
        Once you leave this page, this offers vanishes forever.
      </Content>
      <BottomNote>
        <Middlecontent style={{ marginBottom: 15 }}>
          <div
            style={{
              backgroundColor: "yellow",
              font: `normal normal bold 30px "Georgia"`,
            }}
          >
            NOTE:
          </div>
        </Middlecontent>
        <Note>This book is physically shipped, and there are no refunds.</Note>
        <p>So if you have any doubt, you are better off passing on it:</p>
      </BottomNote>
      <ActionDiv>
        <ActionTitle>Yeah! I'm ready!</ActionTitle>
        <ActionContent>
          I understand that there are no refunds and that all sales are final. I
          also understand that this training is only available within the mobile
          app.
        </ActionContent>
        <BuyButton
          onClick={() => {
            setLoading(true);
            onBuy();
          }}
          isLoading={loading}
        >
          Buy now!
        </BuyButton>
        By clicking above, a total of $320.00 will be charged from your card.
      </ActionDiv>
      <NotAdd onClick={onNoThanks}>
        <b>
          <u>No thanks, please do not add this offer to my purchase.</u>
        </b>
      </NotAdd>
    </UpSaleContainer>
  );
}
